require("writing/quizzes/autosaver.scss");
var Spinner = require("components/utility/Spinner");

var MyShelfRouting = require("lib/routing/MyShelfRouting");

class Autosaver extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { showConfirmDelete: false, changesMade: false,
			autosaveHandler: null, autosaveHash: null };
	}

	toggleConfirmDelete() {
		this.setState({ showConfirmDelete: !this.state.showConfirmDelete });
	}
	redirectToDrafts() {
		this.props.onAutosave(function() {
			window.wrNotifications.triggerDropDownNotification({
				title: "Great!", text: "Your work has been saved!", icon: "ok-sign" });
			if (!this.props.textID || this.props.textID === 'MISSING_TEXT_ID') {
				$wr.redirect(MyShelfRouting.getPath({
					activeView: MyShelfRouting.VIEWS.WORK_VIEW,
					detailsView: "drafts"
				}));
			} else if (this.props.textID) {
				$wr.redirect(MyShelfRouting.getPath({
					activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
					detailsView: "drafts",
					textID: this.props.textID
				}));

			} else {
				$wr.redirect("/");
			}
		}.bind(this));
	}
	unmatchingAutosaveHashes() {
		var autosaveHash = this.props.getAutosaveHash();

		if ((this.state.autosaveHash != null) && (autosaveHash != null)) {
			return (autosaveHash != this.state.autosaveHash);
		} else {
			return false;
		}
	}

	render() {
		if (this.props.autosaveLoading) {
			return (
				<div className="autosaver">
					<Spinner className="draftSpinner" scale={ 0.5 } smallOps={ true } />
					<p className="deleteDraft deleteDraftMessage">
						Your work is saving...
					</p>
					{ deleteOption }
				</div>
			);

		} else if (this.state.showConfirmDelete) {
			return (
				<div className="autosaver autosaverDelete">
					<p className="deleteDraft deleteDraftMessage">
						If you delete this you will lose your work below. Are you sure?
					</p>
					<button key="confirm" className="deleteDraft confirmDelete btn-link" 
						onClick={ this.props.onDeleteClick }>
						Yes
					</button>
					<button key="cancel" className="deleteDraft btn-link"
						onClick={ this.toggleConfirmDelete }>
						No
					</button>
				</div>
			)
		} else {
			if (this.props.onDeleteClick) {
				var deleteOption = (
					<button key="confirm" className="deleteDraft btn-link"
						onClick={ this.toggleConfirmDelete }>
						Delete Draft
					</button>
				);
			}
			if (!this.props.autosaveDisabled) {
				var saveForLaterOption = (
					<button className="saveForLater buttonSuccess btn-link"
						onClick={ this.redirectToDrafts }>
						Save for Later
					</button>
				);

				if (!this.state.changesMade) {
					var changesSavedText = (
						<span className="deleteDraft deleteDraftMessage">
							Your work is saved!
						</span>
					);
				}

			}

			return (
				<div className="autosaver">
					{ changesSavedText }
					<br />
					{ saveForLaterOption }
					{ deleteOption }
				</div>
			);
		}
 	}

 	componentDidMount() {
 		if (!this.props.autosaveDisabled) {
			this.setupAutosaver();
			this.setupChangesCheck(); 			
 		}
	}

	componentWillUnmount() {
		if (!this.props.autosaveDisabled) {
			clearTimeout(this.state.autosaveHandler);
			clearTimeout(this.state.changesCheckHandler);
		}
	}

	tickAutosaving() {
		if (!this.props.autosaveLoading && this.unmatchingAutosaveHashes()) {
			this.props.onAutosave(function() {
				this.setState({ changesMade: false });
				this.setupChangesCheck();
			}.bind(this));
		}
		this.setupAutosaver();
	}
	tickChangesCheck() {
		if ((this.state.autosaveHash != null) && this.unmatchingAutosaveHashes()) {
			this.setState({ changesMade: true });
		} else {
			this.setupChangesCheck();
		}
	}

	setupAutosaver() {
		var autosaveHash = this.props.getAutosaveHash();
		if (autosaveHash != undefined) {
			var autosaveHandler = setTimeout(this.tickAutosaving, Autosaver.AUTOSAVE_INTERVAL);
			this.setState({ autosaveHandler: autosaveHandler, autosaveHash: autosaveHash });
		}
	}
	setupChangesCheck() {
		var changesCheckHandler = setTimeout(this.tickChangesCheck, Autosaver.CHANGES_CHECK_INTERVAL);
		this.setState({ changesCheckHandler: changesCheckHandler });
	}
};

Autosaver.AUTOSAVE_INTERVAL = 15000;
Autosaver.CHANGES_CHECK_INTERVAL = 1000;

Autosaver.propTypes = StrictPropTypes({
	// Gets a value representing the autosave status
	// Changes in the value this returns will trigger the autosave
	getAutosaveHash: PropTypes.func,

	// Function called to run the autosave
	onAutosave: PropTypes.func,

	// Text ID to redirect to appropriate drafts page
	textID: PropTypes.string,

	// Trigger the deletion of the associated draft
	// If not present, we'll hide the option to show this
	onDeleteClick: PropTypes.func,

	// True if a draft is currently being saved
	autosaveLoading: PropTypes.bool,

	// If true, don't do any autosaving (or saving). Just allow deleting.
	// If this value changes, make sure to remount component (e.g. by changing key)
	autosaveDisabled: PropTypes.bool

});

module.exports = Autosaver;



// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/Autosaver.js